import styled from "styled-components"

const Base = styled.div`
  position: relative;
  flex: 1;
  margin: auto;
  max-width: 1180px;
  width: 100%;
`

export default Base
